export function useShadowDOM() {
    const app = document.getElementById('app-root');
    const shadowRoot = app?.shadowRoot;
    const isShadowDOM = !!shadowRoot;
    const shadowStylesInsertionPoint = shadowRoot?.querySelector('#shadow-root-styles');
    const root = isShadowDOM
        ? app.shadowRoot.querySelector('#shadow-root')
        : document;
    return {
        app,
        root,
        shadowRoot,
        isShadowDOM,
        shadowStylesInsertionPoint
    };
}
//# sourceMappingURL=index.js.map